import { render, staticRenderFns } from "./SupplierAnalysisTab.vue?vue&type=template&id=652b8a8a&"
import script from "./SupplierAnalysisTab.vue?vue&type=script&lang=js&"
export * from "./SupplierAnalysisTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports